<template>
  <div id="services" class="services wrrapper">
    <page-heading title="Health Services">
      <template #content>
        <div class="flex align-center">
          <Button
            className="button--primary add-user mr-2"
            title="Add Charges"
            :onClick="addChargez"
          ></Button>
          <Button
            className="button--primary add-user mr-2"
            title="Add Service"
            :onClick="addService"
          ></Button>
          <Input
            type="text"
            v-model="searchText"
            placeholder="Search..."
            icon="mdi-magnify"
            :handleSearch="() => {}"
            :handleReset="handleReset"
            :reset="searchText"
          />
          <Select
            v-if="isAdmin"
            class="ml-2"
            styles="expenses-select"
            :input="handleBranchChange"
            :options="brachData"
            :placeholder="
              brachData.length
                ? brachData &&
                  brachData.find(item => item.key == user.userBranchId).name
                : ''
            "
          />
        </div>
      </template>
    </page-heading>
    <data-table
      :cols="columns"
      :rows="getServices"
      :options="options"
      height="calc(100vh - 15rem)"
      :loading="loading"
    >
      <template slot="action" slot-scope="{ actions }">
        <dropdown-menu
          :rowData="actions"
          :handleItemClick="handleItems"
          :items="items"
        />
      </template>
    </data-table>
    <modal
      title="Add Service"
      name="servicesModal"
      class="custom-modal"
      height="auto"
      width="600"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-1">
          <validation-observer ref="form">
            <form @submit.prevent class="create-service mb-base">
              <Select
                label="Service Head"
                :options="servicesList"
                styles="mb-base"
                :input="handleServices"
                :clearable="false"
                :error="error"
              />
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  class="mb-base"
                  label="Service Name"
                  type="text"
                  :error="errors[0]"
                  v-model="servicesData.name"
                />
              </validation-provider>
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  class="mb-base"
                  label="Amount"
                  type="number"
                  :error="errors[0]"
                  v-model="servicesData.amount"
                />
              </validation-provider>
              <Select
                :options="brachData"
                styles="mb-base"
                style="padding: 1rem 0;"
                :input="handleBranchChangeSerive"
                :clearable="false"
                :placeholder="
                  brachData.length
                    ? brachData && brachData.find(item => item.key == 1).name
                    : ''
                "
                :error="error"
              />
              <Button
                className="button--primary custom-button"
                title="Add Services"
                :onClick="handleAddServices"
                :loader="loading"
              ></Button>
            </form>
          </validation-observer>
        </div>
      </template>
    </modal>

    <modal
      title="Add Charges"
      name="chargezModal"
      class="custom-modal"
      height="auto"
      width="600"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-1">
          <validation-observer ref="form">
            <form @submit.prevent class="create-service mb-base">
              <Select
                label="Service Name"
                :options="serviceList"
                styles="mb-base"
                :input="handleServicesList"
                :clearable="false"
                :error="error"
              />
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  class="mb-base"
                  label="Amount"
                  type="number"
                  :error="errors[0]"
                  v-model="addChargesData.amount"
                />
              </validation-provider>
              <Select
                :options="brachData"
                styles="mb-base"
                style="padding: 1rem 0;"
                :input="val => (addChargesData.branchId = val.key)"
                :clearable="false"
                :placeholder="
                  brachData.length
                    ? brachData && brachData.find(item => item.key == 1).name
                    : ''
                "
                :error="error"
              />
              <Button
                className="button--primary custom-button"
                title="Add Charges"
                :loader="loading"
                :onClick="addCharges"
              ></Button>
            </form>
          </validation-observer>
        </div>
      </template>
    </modal>
    <Edit
      :servicesList="servicesList"
      :currentSelectedBranch="selectedBranch"
      :editDetails="editDetails"
    />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import Select from "@/components/Select";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import Edit from "./edit";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DataTable,
    Select,
    DropdownMenu,
    Button,
    Modal,
    Input,
    Edit
  },
  data() {
    return {
      editDetails: "",
      searchText: "",
      brachData: [],
      servicesData: {},
      selectedBranch: {},
      error: "",
      items: ["Edit Service", "Edit Charges", "Delete Charges"],
      columns: [
        { column: "serial", label: "#", width: 60 },
        { column: "name", label: "Service Name", sortable: true },
        {
          column: "service",
          label: "Service Head",
          sortable: true
        },
        {
          column: "amount",
          label: "Service Fee",
          formatAmount: true,
          sortable: true
        },
        { column: "action", label: "Action" }
      ],
      options: {
        action: true
      },
      isAdmin: false,
      serviceList: [],
      addChargesData: {}
    };
  },
  methods: {
    ...mapActions("services", [
      "addServices",
      "listServices",
      "serviceDetails",
      "deleteServices",
      "filterServices",
      "addServicesCharges",
      "chargeDetail"
    ]),
    ...mapActions("doctors", ["doctorList"]),
    ...mapActions("expenses", ["fetchBranch"]),
    addService() {
      this.$modal.show("servicesModal");
    },
    addChargez() {
      this.$modal.show("chargezModal");
    },
    handleBranchChangeSerive(val) {
      if (val && val !== null) {
        this.servicesData.branchId = val.key;
      }
    },
    handleBranchChange(val) {
      if (val && val != null) {
        this.selectedBranch = val;
        const query = {
          branch: val.key,
          other: this.isOther
        };
        this.filterServices(query);
      }
      if (val === null) {
        this.listServices(this.isOther);
        this.doctorList("servicehead");
        this.selectedBranch = { key: 1, name: "Head Office Branch" };
      }
    },
    handleBranch(val) {
      this.servicesData.branchId = val.key;
    },
    handleReset() {
      this.searchText = "";
    },
    handleServices(val) {
      this.servicesData.lookupId = val.id;
    },
    handleAddServices() {
      this.$refs.form.validate().then(success => {
        if (!this.servicesData.lookupId) {
          this.error = "This field is required";
        }
        if (!success) {
          return;
        }

        if (this.servicesData.lookupId) {
          if (this.servicesData.branchId == undefined) {
            this.servicesData.branchId = this.user.userBranchId;
          }
          this.addServices({
            ...this.servicesData,
            isOther: this.isOther
          }).then(() => {
            this.$modal.hide("servicesModal");
            this.servicesData = {};
          });
        }
      });
    },
    async handleItems(item, rowData) {
      if (item == "Edit Service") {
        this.$modal.show("editServices");
        this.editDetails = "service";
        await this.serviceDetails(rowData.id);
        if (!this.selectedBranch.key) {
          this.selectedBranch.key = this.user.userBranchId;
        } else {
          this.selectedBranch;
        }
      } else if (item == "Edit Charges") {
        this.editDetails = "charge";
        this.$modal.show("editServices");
        const chargeData = this.listItems.find(
          obj => obj.serviceId === rowData.id
        );
        this.chargeDetail(chargeData.id);
        if (!this.selectedBranch.key) {
          this.selectedBranch.key = this.user.userBranchId;
        }
      } else if (item == "Delete Charges") {
        const data = {
          serviceId: rowData.chargeId,
          branchId: rowData.branchId,
          id: 1
        };
        this.deleteServices(data);
        const query = {
          branch: this.selectedBranch.key,
          other: this.isOther
        };
        this.filterServices(query);
      }
    },
    handleServicesList(val) {
      this.addChargesData.serviceId = val.key;
    },
    addCharges() {
      this.$refs.form.validate().then(success => {
        if (!this.addChargesData.serviceId) {
          this.error = "This field is required";
        }

        if (!success) {
          return;
        }

        if (this.addChargesData.serviceId) {
          const data = {
            serviceId: this.addChargesData.serviceId,
            amount: this.addChargesData.amount,
            branchId: this.addChargesData.branchId
          };
          this.addServicesCharges(data).then(() => {
            this.addChargesData = {};
            this.$modal.hide("chargezModal");
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      listItems: "services/listItems",
      listDoctors: "doctors/listDoctors",
      role: "auth/role",
      isOther: "auth/isOther",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch",
      detailsService: "services/detailsService",
      chargeId: "services/chargeId"
    }),
    getServices() {
      const data = this.listItems;
      if (this.searchText) {
        const results = data.filter(
          item =>
            item.service &&
            item.service.name
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase()) !== -1
        );
        return results.map(item => ({
          name: item.service.name,
          service:
            item.service && item.service.lookup && item.service.lookup.name,
          amount: item.amount,
          id: item.service.id,
          branchId: item.branchId,
          chargeId: item.id
        }));
      } else {
        return data
          ? data.map(item => ({
              name: item.service.name,
              service:
                item.service && item.service.lookup && item.service.lookup.name,
              amount: item.amount,
              id: item.service.id,
              branchId: item.branchId,
              chargeId: item.id
            }))
          : null;
      }
    },
    servicesList() {
      return (
        this.listDoctors &&
        this.listDoctors.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    }
  },
  async created() {
    //
    await this.fetchBranch();
  },
  async mounted() {
    if (this.selectedBranch.key === undefined) {
      this.selectedBranch = {
        key: this.user.userBranchId,
        name: "Head Office"
      };
    }
    this.isAdmin = this.role.some(({ name }) => name === "admin");
    await this.listServices(this.isOther);
    await this.doctorList("servicehead");
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    for (let item of this.listItems) {
      const service = item.service;
      this.serviceList.push({ key: service.id, name: service.name });
    }
  }
};
</script>

<style scoped>
/* ── Services index ────────────────────────────────────────── */
.create-service {
  display: flex;
  flex-direction: column;
}

/* Full-width submit inside modal forms */
.custom-button {
  width: 100%;
  margin-top: 4px;
}
</style>
